import { CardContent, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import { Add, FileUpload, FilterAlt } from "@mui/icons-material"
import MaterialButton from "../../../components/MaterialButton"
import Table from "../../../components/Table"
import { useEffect, useState } from "react"
import { deleteData, fetchData, postData } from "../../../services"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import UploadFile from "../../Utils/UploadFile"
import { useSnackbar } from "../../../context/popup"
import InsurerCoverageFilterDialog from './components/InsurerCoverageFilterDialog.js';

const InsurerCoverageList = () => {
    
    const { showSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentPage = useSelector((state) => state?.insurerCoverageStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.insurerCoverageStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.insurerCoverageStore?.totalPages);
    const [insurerCoverageData, setInsurerCoverageData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);    

    const [search, setSearch] = useState("");

        //dialogstate
    const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
    const [fileUploading, setFileUploading] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [clearFileOnSuccess, setClearFileOnSuccess] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        gInsurerId: "",
        gProductId: "",
        gPolicyTypeId: ""
    });

    useEffect(() => {
        fetchCoverageList();
    },[isRefresh, currentPage, rowsPerPage,search])

    const handleSearch = (value) => {
        setSearch(value);
    };

    //List API
    const fetchCoverageList = async () => {
        try {
        let url = `/reference/insurer/coverage?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}&gProductId=${filterData.gProductId}&gPolicyTypeId=${filterData.gPolicyTypeId}`;
                                    
        //for active and inactive status
        if(filterData.isActive !== "") {
            url += `&isActive=${filterData.isActive}`;
        }
        if(filterData.gInsurerId !== "") {
            url += `&gInsurerId=${filterData.gInsurerId}`;
        }    
    
        const response = await fetchData(url);
        if(response?.success){
            setInsurerCoverageData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));     
        }
        else{
            //throw error
            showSnackbar("Error fetching Coverage","error");
        }
        } catch (error) {
            console.error('Error Fetching Addons:', error);
            showSnackbar(error?.response?.data?.message || "Error fetching Coverage","error");
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/reference/insurer/coverage-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message,"success");
            }
            else{
                showSnackbar(response?.message,"error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar("Error deleting","error");
        }
    };

   //bulk file upload api function
        const handleFileUploadSuccess = async (file) => {
            setFileUploading(true)
            setUploadSuccess(false)
            
            try {
                const formData = new FormData()
    
                formData.append('file', file)
    
                const result = await postData(`/reference/motor/insurer/bulkUpload/insurer-coverage`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });        
    
                if (result?.success) {
                    setUploadSuccess(true)
                    showSnackbar(result?.message,"success");
                    setOpenUploadFileDialog(false);
                    setClearFileOnSuccess(true);
                    fetchCoverageList(); 
                }
                else {
                    setUploadSuccess(false);
                    showSnackbar('Faiiled to upload file', "error")
                }
    
            } catch (error) {
                    const errorMessage = error?.response?.data?.message;                
                    console.error('Upload error:', error || errorMessage)
                    showSnackbar(errorMessage, "error")
            } 
            finally {
                    setFileUploading(false)
            }
        };


       //Table Mapping
    const insurerCoverageTable = {
        columns: [
            {
            key: "sno",
            label: "S.No.",
            renderCell: (row) => row.sno,
            },
            {
            key: "code",
            label: "Coverage Code",
            renderCell: (row) => row.code,
            },
            {
            key: "name",
            label: "Coverage Name",
            renderCell: (row) => row.name,
            },
            {
            key: " ",
            label: "Insurer Name",
            renderCell: (row) => row.gInsurerName,
            },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
        ],
        rows: insurerCoverageData?.map((item, index) => ({
            id: item?.id,
            sno: index + 1,
            code: item?.code || "",
            name: item?.name || "",
            gInsurerName: item?.gInsurerName || "",
            isActive: item?.isActive,
        })),
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/insurer-master/insurer-coverage/coverage-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/insurer-master/insurer-coverage/coverage-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleAddNewCoverage = () => {
        navigate(`/insurer-master/insurer-coverage/coverage-details`)
    }

  return (
    <DashboardLayout>
        <CardHeader title={(
        <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
        >
            <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                    Insurer Coverage List
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                    List of Coverages linked to Insurers.
                </MaterialTypography>
            </Stack>
            <Stack direction="row" spacing={1}>
                 <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<FilterAlt/>}
                onClick={(event) => setAnchorEl(event.currentTarget)}
                >
                Filter
                </MaterialButton>
                <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<FileUpload/>}
                onClick={() => setOpenUploadFileDialog(true)}                
                >
                    Bulk Upload
                </MaterialButton>
                <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<Add />}
                    onClick={() => handleAddNewCoverage()}
                >
                    Coverage
                </MaterialButton>
            </Stack>
        </Stack>
        )} 
        />
        <CardContent>
            <Table
            columns={insurerCoverageTable?.columns}
            data={insurerCoverageTable?.rows}
            actions={actions}
            pagination={{
                totalPages,
                currentPage,
                onPageChange: (page) => handlePaginationChange(page),
                rowsPerPage,
                onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                rowsPerPageOptions: [5, 10, 15, 20],
            }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel="No Insurer Coverages found"
            handleSearch={handleSearch}
            />
        </CardContent>        
        <UploadFile
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        onUploadSuccess={handleFileUploadSuccess}
        fileTypes={['csv', 'xlsx']}
        fileUploading={fileUploading}
        uploadSuccess={uploadSuccess}
        setUploadSuccess={setUploadSuccess}
        setFileUploading={setFileUploading}
        clearFileOnSuccess={clearFileOnSuccess}
        />
        <InsurerCoverageFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchCoverageList();  // call API after filter applied
        }}
        />
    </DashboardLayout>
  )
}

export default InsurerCoverageList